import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import * as userReducer from '../../reducers/userReducer';
import { startRequestCode } from '../../actions/signup-sync';
import { BODY_TEXT_COLOR } from '../../config/colors';

import './style.css';
import { formatPhone } from '../../helpers/normalizePhone';

const styles = {
  text: { margin: '20px 0', textAlign: 'center' },
  labelStyle: { fontWeight: 700 },
};
class SignUpConfirmModal extends Component {
    handlePositiveClick = () => {
      // send user data, request code
      this.props.requestCode(this.props.user.id);
    }

    getPhoneFormatted = () => formatPhone(this.props.tempUserPhone);

    render() {
      return (
        <Modal overlayTop={0} closeOnOutsideClick={false} isOpened onClose={null}>
          <div style={{ margin: '20px 0' }}>
            <div className="signup-confirm">
              <HeaderDiv style={styles.welcomeTxt}>THANK YOU</HeaderDiv>
              <TextDiv>
                <div>You will get an authentication code momentarily. Please tap proceed to authenticate with your unique code.</div>
                <div style={{ margin: '20px 0 0 0' }}>A text message will be sent to the email provided.</div>
              </TextDiv>
              <div>
                <RaisedButton
                  onClick={this.handlePositiveClick}
                  backgroundColor={`#${this.props.secondaryColor}`}
                  labelColor="#FFF"
                  label="Proceed"
                  labelStyle={styles.labelStyle}
                />
              </div>
            </div>
          </div>
        </Modal>
      );
    }
}

const mapStateToProps = state => ({
  tempUserName: userReducer.getTempUserName(state),
  tempUserPhone: userReducer.getTempUserPhone(state),
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
  user: state.user.tempUser,
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modal.hideModal()),
  requestCode: customerId => dispatch(startRequestCode(customerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpConfirmModal);

const HeaderDiv = styled.div`
  font-size: 39px;
  line-height: 39px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  text-align: center;
`;
const TextDiv = styled.div`
  font-family: 'Roboto', sans-serif;
  color: ${BODY_TEXT_COLOR};
  font-weight: 400;
  margin: 20px 0 20px;
  text-align: center;
  font-size: 18px;
  max-width: 379px;
  line-height: 23px;
`;



// WEBPACK FOOTER //
// ./src/components/SignUpConfirmModal/SignUpConfirmModal.jsx